import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import PageLoader from '../loaders/pageLoader';

const TosPage = lazy(() => import('../../components/pages/userAccount/tosPage'));

const tosPath = '/tos' as const;

export const tosRoutes = {
	path: tosPath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<Suspense fallback={<PageLoader />}>
					<TosPage />
				</Suspense>
			),
		},
	],
};
